const getScoreStyle = (score) => {
  const n = typeof score === "number" ? score : parseFloat(score);

  if (!n && n !== 0) return {};
  if (n < 30) return { borderColor: "var(--border-red)", background: "var(--red)" };
  if ((n >= 30) && (n < 40)) return { borderColor: "var(--border-blue)", background: "var(--blue)" };
  if ((n >= 40) && (n < 50)) return { borderColor: "var(--border-yellow)", background: "var(--yellow)" };
  if ((n >= 50) && (n < 60)) return { borderColor: "var(--border-purple)", background: "var(--purple)" };
  if (n >= 60) return { borderColor: "var(--border-green)", background: "var(--green)" };
  return { borderColor: "var(--border-red)", background: "var(--red)" };
};

export const getFieldStyle = (field, value) => {
  // Define rules for fields; you can add more as needed.
  const rules = {    
    eduAna:{
      "Not Suitable": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Suitable: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
    },    
    expAna:{
      UnderExp: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      OverExp: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Suitable: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
    },        
    finalScore: {
      "Partial Suitable": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
      },      
      "Not Suitable": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Below Average": {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },
      Average: {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      "Above Average": {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      "Good Match": {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
      "Partial Suitable": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
      }
    },
    resumeSuitability: {
      "Partial Suitable": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
        color:"var(--border-orange)",         
      },      
      "Not Suitable": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
        color:"var(--border-red)", 
      },
      "Below Average": {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
        color:"var(--border-blue)", 
      },
      Average: {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
        color:"var(--border-yellow)",      
      },
      "Above Average": {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
        color:"var(--border-purple)",        
      },
      "Good Match": {
        borderColor: "var(--border-green)",
        background: "var(--green)",
        color:"var(--border-green)",
      },
      "Partial Suitable": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
        color:"var(--border-orange)",
      },      
    },        
    candidateStatus: {
      Available: {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
        color: "var(--border-blue)",
      },
      Sourced: {
        borderColor: "var(--border-pink)",
        background: "var(--pink)",
        color: "var(--border-pink)",
      },     
      "Not Picking": {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
        color: "var(--border-purple)",
      },
      Busy: {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
        color: "var(--border-orange)",
      },
      "Call Later": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
        color: "var(--border-yellow)",
      },
      "Not Interested": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
        color: "var(--border-red)",
      },
      "Not Looking": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
        color: "var(--border-red)",
      },
      "Not Suitable": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
        color: "var(--border-red)",
      },  
      "Resume Pending": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
        color: "var(--border-grey)",
      },                
      "Location Issue": {
        borderColor: "var(--border-purple)",
        background: "var(--green)",
        color: "var(--border-green)",
      },
      "JD Needed": {
        borderColor: "var(--border-green)",
        background: "var(--green)",
        color: "var(--border-green)",
      },
      "Direct Payroll": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
        color: "var(--border-red)",
      },
      Disconnected: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
        color: "var(--border-green)",
      },
      OOS: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
        color: "var(--border-green)",        
      },
      SwitchOFF: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
        color: "var(--border-green)",        
      },     
      "Already Got Call": {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      "Already Applied": {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      "Interview within 6 Months": {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },
      "Interview before 6 months": {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },
      "To Be Called": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
        
      },
    },

    resumeStatus: {
      "Shared": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
      },
      "Review Pending": {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },
      "Feedback Pending": {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },  
      "Client Feedback Pending": {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },        
      "To Be Shared": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      "Screen Partial Suitable": {
        borderColor: "var(--border-lightgreen)",
        background: "var(--lightgreen)",
      },  
      "Screen Rejected": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      }, 
      "Screen Rejected HCTC": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      }, 
      "Screen Rejected HNP": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },             
      "Screen Selected": {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      }, 
      "Duplicate": {
        borderColor: "var(--border-pink)",
        background: "var(--pink)",
      }, 
      "Interview Rejected": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },                             
    },
    iStatus: {
      YTBS: {
        borderColor: "var(--border-pink)",
        background: "var(--pink)",
      },
      YTBRRS: {
        borderColor: "var(--border-pink)",
        background: "var(--pink)",
      },
      Scheduled: {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },
      Rescheduled: {
        borderColor: "var(--border-blue)",
        background: "var(-blue)",
      },
      Cancel: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      IFP: {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      "No Panel": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      "Candidate Drop": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Candidate NP": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Panel Not Joined": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Candidate No Show": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Candidate On Hold": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      Rejected: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Selected: {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      "Final Select": {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
    },
    interviewStatus: {
      YTBS: {
        borderColor: "var(--border-pink)",
        background: "var(--pink)",
      },
      YTBRRS: {
        borderColor: "var(--border-pink)",
        background: "var(--pink)",
      },
      Scheduled: {
        borderColor: "var(--border-blue)",
        background: "var(--blue)",
      },
      Rescheduled: {
        borderColor: "var(--border-blue)",
        background: "var(-blue)",
      },
      Cancel: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      IFP: {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      "No Panel": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      "Candidate Drop": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Candidate NP": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Panel Not Joined": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Candidate No Show": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      "Candidate On Hold": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      Rejected: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Selected: {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      "Final Select": {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
    },

    jdStatus: {
      Active: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
      Closed: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Expired: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },      
      "Hold Pipeline": {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
      "Hold Selection": {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      "Hold Interview": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
      },
      "Hold FB Pending": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
      },
    },
    jdPermission: {
      Private: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Public: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
      Protected: {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
    },    
    jdIndexed: {
      "Not Indexed": {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Indexed: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
    },      

    jdStatusDot: {
      Active: {
        color: "var(--border-green)",
      },
      Closed: {
        color: "var(--border-red)",
      },
      "Hold Pipeline": {
        color: "var(--border-yellow)",
      },
      "Hold Selection": {
        color: "var(--border-purple)",
      },
      "Hold Interview": {
        color: "var(--border-yellow)",
      },
      "Hold FB Pending": {
        color: "var(--border-orange)",
      },
    },

    jdPriority: {
      Low: {
        borderColor: "var(--border-red)",
        background: "var(--red)",
      },
      Normal: {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      High: {
        borderColor: "var(--border-green)",
        background: "var(--green)",
      },
      Urgent: {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
      },
      Todays: {
        borderColor: "var(--border-yellow)",
        background: "var(--yellow)",
      },
    },

    jdPriorityDot: {
      Low: {
        color: "var(--border-red)",
      },
      Normal: {
        color: "var(--border-purple)",
      },
      High: {
        color: "var(--border-green)",
      },
      Urgent: {
        color: "var(--border-orange)",
      },
      Todays: {
        color: "var(--border-yellow)",
      },
    },

    extraAnalysis: {
      Suitable: {
        borderColor: "var(--border-green)",
        background: "var(--lighter-green)",
        color:"var(--border-green)",
      },
      HCTC: {
        borderColor: "var(--border-purple)",
        background: "var(--purple)",
      },
      HNP: {
        borderColor: "var(--border-r)",
        background: "var(--purple)",
      },
      "HCTC + HNP": {
        borderColor: "var(--border-orange)",
        background: "var(--orange)",
      }
    },

    // Add this new entry for noticePeriod
    noticePeriod: {
      getStyle: (days) => {
      const numDays = Number(days);

      if (days == "" || days == "--") {
          return undefined
      }

        if (days <= 15) {
          return {
            borderColor: "var(--border-green)",
            background: "var(--green)",
          };
        } else if (days <= 30) {
          return {
            borderColor: "var(--border-yellow)",
            background: "var(--yellow)",
          };
        } else if (days <= 60) {
          return {
            borderColor: "var(--border-orange)",
            background: "var(--orange)",
          };
        } else {
          return {
            borderColor: "var(--border-red)",
            background: "var(--red)",
          };
        }
      },
    },   
    // Add this new entry for noticePeriod
    skillAna: {  
      getScoreStyle 
    },    
    // Add this new entry for noticePeriod
    resumeSuitabilityScore: {  
      getScoreStyle 
    }, 
    // Add this new entry for noticePeriod
    roleAna: {  
      getScoreStyle 
    },    
  };
        
  // Special handling for noticePeriod since it uses numeric logic
  if (field === "noticePeriod" || field === "noticePeriodOfficial" || field === "noticePeriodNegotiable") {
    return rules.noticePeriod.getStyle(value);
  }
  if (field === "resumeSuitabilityScore" ) {
    return rules.resumeSuitabilityScore.getScoreStyle(value);
  }
  if ( field === "skillAna") {
    return rules.skillAna.getScoreStyle(value);
  }
  if ( field === "roleAna" ) {
    return rules.roleAna.getScoreStyle(value);
  } 
 
  return rules[field] && rules[field][value] ? rules[field][value] : undefined;
};
